enum PerkClassTypeIds {
  FullTimeId = 1,
  PartTimeId,
  SalariedId,
  HourlyId,
  ExecutiveId,
  ManagerId,
  StaffId,
  AllEligibleEmployeesId,
}

export default PerkClassTypeIds
